import { TableRow, TableCell } from '@mui/material';
import { AssociatedTeamMember, DataRoomUser, UnlockUser } from '../../../shared/models';
import { TeamMemberActionButton } from './TeamMemberActionButton';

interface ITeamMemberItemProps {
	isEmployee: boolean;
	user: DataRoomUser;
	member: AssociatedTeamMember;
	removeTeamMember: (member: AssociatedTeamMember) => void;
	sendInvite: (member: UnlockUser) => void;
}

export const TeamMemberItem: React.FC<ITeamMemberItemProps> = ({
	isEmployee,
	user,
	member,
	removeTeamMember,
	sendInvite,
}) => {
	return (
		<TableRow>
			<TableCell sx={{ minWidth: 250 }}>
				{member.firstName} {member.lastName}
			</TableCell>
			<TableCell sx={{ minWidth: 300 }}>{member.emailAddress}</TableCell>
			<TableCell>
				<TeamMemberActionButton
					isEmployee={isEmployee}
					user={user}
					member={member}
					removeAccess={removeTeamMember}
					sendInvite={sendInvite}
				/>
			</TableCell>
		</TableRow>
	);
};
